import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title:'智慧云',
    tableHeight:200,
    activeRouter:'/WisdomCloud/Index',
  },
  mutations: {
    update(state,[key,value]){
        state[key]=value;
    },
  },
  actions: {
  },
  modules: {
  }
})
